import CardComponent from "./CardComponent";
import "./CardComponent.scss";
import uploadIcon from '../../../../../assets/icons/icon-individualTherapy.svg';
import { deepClone, findGridType, groupOffice } from "../../../../../legacy/utils/helpers";
import { useState, useEffect } from "react";


interface props {
    choices?: Array,
    onChange?: Function,
    className?: string,
    questionMetaData: ?any
}


const CardComponentContainer = ({ choices, onChange, className, questionMetaData }: props) => {
    const [isAnySelected, setIsAnySelected] = useState(false);
    let currentChoices = deepClone(choices);
    const [groupedOffices, setGroupedOffices] = useState({});


   

      useEffect(() => {
          // Group offices by regionName if isAddressInfoPage is true
          setGroupedOffices(groupOffice(questionMetaData?.metadata?.isAddressInfoPage,currentChoices));
      }, []);

    // if in current choices any of the choice is selecetd true the it setIsAnySelected true OW false 
    useEffect(() => {
        const found = currentChoices.find(c => c.selected === true);

        if (found) {
            return setIsAnySelected(true);
        }

        setIsAnySelected(false);
    }, [currentChoices]);

    const onChangeSelection = (s: Boolean, choice: any) => {
        currentChoices = currentChoices.map((c) => {

            if (c.id === choice.id) {
                c.selected = s;
                if (s) c.value = c.title;
            }

            return c;
        });
        setGroupedOffices(groupOffice(questionMetaData?.metadata?.isAddressInfoPage,currentChoices));
        onChange(null, currentChoices);
    };

    return (
    <div className={` row ${className}`}>
           {Object.entries(groupedOffices).map(([region, offices]) => (
               <div className="text-center mt-4" key={region}>
                   {region && <h2>{region}</h2>}
                   <div
                       className={`grid-container card-component-container layout-grid-${findGridType(offices.length)} ${
                           questionMetaData?.metadata?.isAddressInfoPage
                               ? "address-grid"
                               : ""
                       }`}
                   >
                       {offices.map((office: any) => (
                           <CardComponent
                               key={office.unique_key}
                               isAnySelected={isAnySelected}
                               selected={office.selected}
                               onChange={(selected: boolean) =>
                                   onChangeSelection(selected, office)
                               }
                               color={"orange"}
                               choice={office}
                               icon={uploadIcon}
                               isAddressInfoPage={
                                   questionMetaData?.metadata?.isAddressInfoPage
                               }
                           />
                       ))}
                   </div>
               </div>
           ))}
       </div>
   );
};

export default CardComponentContainer;